var React = require('react');

function BulletPlusBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.59,9A17.71,17.71,0,0,1,36,18a17.71,17.71,0,0,1-2.41,9A18,18,0,0,1,27,33.59,17.61,17.61,0,0,1,18,36a17.61,17.61,0,0,1-9-2.41A18,18,0,0,1,2.41,27,17.61,17.61,0,0,1,0,18,17.61,17.61,0,0,1,2.41,9,18,18,0,0,1,9,2.41,17.71,17.71,0,0,1,18,0a17.71,17.71,0,0,1,9,2.41A18,18,0,0,1,33.59,9ZM28.5,19.5v-3A1.54,1.54,0,0,0,27,15H21V9a1.54,1.54,0,0,0-1.5-1.5h-3A1.54,1.54,0,0,0,15,9v6H9a1.54,1.54,0,0,0-1.5,1.5v3A1.54,1.54,0,0,0,9,21h6v6a1.54,1.54,0,0,0,1.5,1.5h3A1.54,1.54,0,0,0,21,27V21h6a1.54,1.54,0,0,0,1.5-1.5Z","style":{"fill":"#5bbfec"}}));
}

BulletPlusBlue.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = BulletPlusBlue;

BulletPlusBlue.default = BulletPlusBlue;
